window.TV2 = window.TV2 || {};

window.TV2.initVurderinger = () => {
  window.addEventListener('message', (message) => {
    if (message && message.data) {
      window.dataLayer.push({
        event: message.data.event,
        eventCategory: message.data.eventCategory,
        eventAction: message.data.eventAction,
        eventLabel: message.data.eventLabel,
      });
    }
  });
};
